module.exports = __webpack_public_path__ + "static/img/game-logo-habanero.6eb5905.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-habanero.png
// module id = lgVP
// module chunks = 0 1 2 3 4 5 6